import React from 'react'
import teamimg from '../imgs/team.png';
function team() {
  return (
    <section id='team' className='team pt-0'>
      <div className='container'>
        <div className='bg-light rounded-4 pt-5'>
            <div className='heading-sec text-center ps-lg-5 w-75 m-auto'>
                <div className='strip-heading'>Team</div>
                <h2 className='h3-heading text-dark'>The Spark Behind BrightSites</h2>
                <div className='h5-heading mb-3'>Meet the creative minds powering your digital success.</div>
                <p>Etiam sed odio dictum, tempus velit non, sollicitudin neque. Donec quis aliquet velit. Aliquam convallis dapibus purus. Etiam sed odio dictum, tempus velit non, sollicitudin neque.</p>
            </div>
            <img className='w-100 rounded-4' src={teamimg} alt="Our team" />
            </div>
        
      </div>
    </section>
  )
}

export default team
